import { Avatar, Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { FaTimesCircle } from "react-icons/fa";
import MeetingMessagingTextBox from "./MeetingMessagingTextBox";
import Draggable from "react-draggable";
export const chats = [
  {
    text: "Click the link to authenticate this transaction or enter a SECUREPASS token below if you have one.Click the link to authenticate this transaction or enter a SECUREPASS token below if you have one. ",
    id: "1",
  },
  {
    text: " I’m fine, thank you! And what about you? Is everything ok?",
    id: "2",
  },
  {
    text: "Click the link to authenticate this transaction or enter a SECUREPASS token below if you have one.Click the link to authenticate this transaction or enter a SECUREPASS token below if you have one. ",
    id: "3",
  },
  {
    text: " I’m fine, thank you! And what about you? Is everything ok?",
    id: "4",
  },
  {
    text: "Click the link to authenticate this transaction or enter a SECUREPASS token below if you have one.Click the link to authenticate this transaction or enter a SECUREPASS token below if you have one. ",
    id: "5",
  },
];
function MeetingMessaging({ showMessaging, setShowMessaging, ...props }) {
  const containerBgColor = useColorModeValue("#fff", "#07182E");
  const textColor = useColorModeValue("#000", "#000");

  return (
    showMessaging && (
      <Draggable
      >
        <Flex
          position={"relative"}
          zIndex="19800"
          bg={containerBgColor}
          boxShadow="lg"
          w="350px"
          maxW="350px"
          flexDirection={"column"}
          p="15px"
          borderRadius={"20px"}
          {...props}
        >
          <Flex justifyContent={"space-between"} mb="10px">
            <Box w="30px" />
            <Text fontWeight={"800"} fontSize="1.2em">
              Chat
            </Text>

            <FaTimesCircle
              cursor={"pointer"}
              onClick={() => setShowMessaging(false)}
              color="#ADADAD"
              fontSize={"1.5em"}
            />
          </Flex>
          <Flex
            flexDirection={"column"}
            gap="20px"
            h="200px"
            overflowY={"scroll"}
            className="scroll-container"
            mb="20px"
          >
            {chats?.map((data) => (
              <Flex
                flexDirection={"row"}
                alignItems="flex-start"
                key={data?.id}
                gap="5px"
                mr="5px"
              >
                <Avatar border="2px solid #fff" size="xs" />
                <Text
                  fontSize={".6em"}
                  maxW="250px"
                  whiteSpace="pre-wrap"
                  bg="#E4E4E4"
                  p="7px"
                  borderRadius={"6px"}
                  color={textColor}
                >
                  {data?.text}
                </Text>
              </Flex>
            ))}
          </Flex>

          <MeetingMessagingTextBox />
        </Flex>
      </Draggable>
    )
  );
}

export default MeetingMessaging;
